import React, { useRef } from 'react'
import {
  Text,
  Box,
  Image,
  IcoMoon,
  CameraIcon,
  CancelIcon,
} from '@usap/uicomponents'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import ImageUploadWMO from './ImageUploadWMO'

const ImageUpload = props => {
  const {
    attr,
    widgets,
    onChange,
    formFile,
    defaultImage,
    removeImage,
    selectedPart,
    isDesktop,
    required,
  } = props

  const file = useRef(null)

  const isWmoEnabled = useWmoEnabled()

  if(isWmoEnabled) {
    return (<ImageUploadWMO 
      {...props}
    />)
  }

  return (
    <Box
      width={isDesktop ? '100px' : '80px'}
      height={isDesktop ? '120px' : '100px'}
      style={{
        marginRight: isDesktop ? '15px' : '4px',
        fontSize: '14px',
        textAlign: 'center',
      }}
    >
      {formFile[attr.id] && (
        <>
          <Image
            width={isDesktop ? '100px' : '80px'}
            height={isDesktop ? '120px' : '80px'}
            className="lazyload"
            src={formFile[attr.id] ? formFile[attr.id].file : defaultImage}
            fit="cover"
            onClick={() => {
              file.current.click()
            }}
            cloudinaryParams="h_210,w_210"
            style={{
              alignSelf: 'center',
              border: '1px solid #ccc',
              cursor: 'pointer',
            }}
          />
          <IcoMoon
            icon={CancelIcon}
            color="#FFF"
            size="small"
            onClick={() => removeImage(attr.id, widgets, selectedPart)}
            style={{
              position: 'absolute',
              marginLeft: isDesktop ? '75px': '57px',
              cursor: 'pointer',
            }}
          />
          <input
            accept=".jpg, .jpeg, .gif, .png, .bmp"
            ref={file}
            onChange={onChange}
            name={selectedPart}
            widgetreq={required ? 'true' : ''}
            id={attr.id}
            type="file"
            style={{ visibility: 'hidden', width: '1px', height: '1px' }}
          />
        </>
      )}

      {!formFile[attr.id] && (
        <>
          <input
            accept=".jpg, .jpeg, .gif, .png, .bmp"
            ref={file}
            onChange={onChange}
            name={selectedPart}
            widgetreq={required ? 'true' : ''}
            id={attr.id}
            type="file"
            style={{ visibility: 'hidden', width: '1px', height: '1px' }}
          />
          <Box
            height="100px"
            width="100px"
            style={{
              border: '1px solid #ccc',
              cursor: 'pointer',
              paddingTop: isDesktop ? '30px' : '22px',
              alignSelf: 'center',
            }}
            onClick={() => {
              file.current.click()
            }}
          >
            <IcoMoon
              icon={CameraIcon}
              color="#05629b"
              size={isDesktop ? '30px' : '22px'}
              style={{ alignSelf: 'center' }}
            />
          </Box>
        </>
      )}
      <Text size="small" margin={{ top: '8px' }}>
        {attr.label}
      </Text>
    </Box>
  )
}

export default ImageUpload
